import React from 'react'

import { Field } from 'formik'

import { Form } from '_zari/core'

const FlagVendedorEnVentasFormGroup = ({ iValue, fIsSubmitting }) => {
  return (
    <Field name='flagVendedorEnVentas'>
      {({ field }) => (
        <Form.Checkbox {...field} checked={iValue} disabled={fIsSubmitting} id='checkbox-flagVendedorEnVentas' label='Vendedor en Ventas' />
      )}
    </Field>
  )
}

export default React.memo(FlagVendedorEnVentasFormGroup)
